// extracted by mini-css-extract-plugin
export default {"ContinueReadingContainer":"qPxZAEkSgjPOKt6Z7WZ2","briefingBody":"SS67LifEwIhJ0Xb5uRT3","firstThreeWord":"ydvcs94OLX45qtnMqZgm"};